// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";

export const Container = styled.div`
    height: calc(100% - 76px);
    margin: 0 1rem 1rem 1rem;
    overflow-y: auto;
    overflow-x: hidden;
`;